import React, { useEffect, useState } from 'react';

/**
 * Vlajka země.
 *
 * Vlajky jsou emoji složené ze dvou „regionálních indikátorů". Apple, Android
 * i většina Linuxů je nakreslí jako vlajku – Windows ne, tam se ukážou jen dvě
 * písmena. Nechat to tak by vypadalo jako chyba, tak si nejdřív ověříme, jestli
 * je systém umí, a když ne, nakreslíme vlastní štítek s kódem země.
 *
 * Zjišťuje se to jednou za načtení stránky: vlajka je pro systém, který ji umí,
 * jeden znak, takže vyjde užší než dvě písmena vedle sebe.
 */

let umiVlajky = null;

function zjistiPodporu() {
  if (umiVlajky !== null) return umiVlajky;
  if (typeof document === 'undefined') return false;
  try {
    const platno = document.createElement('canvas').getContext('2d');
    if (!platno) return false;
    platno.font = '20px sans-serif';
    const vlajka = platno.measureText('\u{1F1E8}\u{1F1FF}').width;  // 🇨🇿
    const pismena = platno.measureText('CZ').width;
    umiVlajky = vlajka < pismena * 0.95;
  } catch {
    umiVlajky = false;
  }
  return umiVlajky;
}

export default function Flag({ emoji, iso2, size = 'md', className = '' }) {
  const [umi, setUmi] = useState(false);

  useEffect(() => { setUmi(zjistiPodporu()); }, []);

  const rozmery = {
    sm: { emoji: 'text-sm', stitek: 'text-[9px] px-1 py-[1px]' },
    md: { emoji: 'text-lg', stitek: 'text-[10px] px-1.5 py-0.5' },
    lg: { emoji: 'text-3xl', stitek: 'text-sm px-2 py-1' },
  }[size] || {};

  if (umi && emoji) {
    return (
      <span className={`${rozmery.emoji} leading-none ${className}`} aria-hidden="true">{emoji}</span>
    );
  }

  // Náhrada pro systémy bez vlajek – ať to vypadá jako záměr, ne jako rozbitý znak.
  return (
    <span
      aria-hidden="true"
      className={`inline-flex items-center justify-center rounded-[4px] bg-bloom-violet/10 text-bloom-violet font-semibold tracking-wide ${rozmery.stitek} ${className}`}
    >
      {(iso2 || '??').toUpperCase()}
    </span>
  );
}
